<template>
  <div class="flex items-center rounded-2xl bg-[#F3F3F3] p-2 md:w-min">
    <slot />
  </div>
</template>
